import { styled } from '@linaria/react';
import { radius, semantic, size, space } from '../../theme/tokens';

export const Card = styled.div`
  background: ${semantic.bg.canvas};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('card', 'radius-md')};
  padding: ${space['space-600']};
  box-sizing: border-box;
`;
